import { Tooltip } from "antd";

interface DataMenuIconProps {
    icon: JSX.Element;
    onClick: (toolId: string) => void;
    menuItem: string;
    activeMenuItem: string | null;
    title: string
}

function DataMenuBarIcon({ icon, onClick, menuItem, activeMenuItem, title }: DataMenuIconProps) {
    return (
        <Tooltip title={title} placement="left">
            <div
                onClick={() => onClick(menuItem)}
                className={activeMenuItem === menuItem ? "active" : ""}
            >
                {icon}
            </div>
        </Tooltip>
    )
}

export default DataMenuBarIcon;